(function () {
  'use strict';

  var AUTH_INTENT_KEY = 'beefcakeClubAuthIntent';
  var AUTH_INTENT_MAX_AGE = 30 * 60 * 1000;
  var eventSequence = 0;

  function createEventId(eventName) {
    eventSequence += 1;
    return [eventName, Date.now(), eventSequence].join('-');
  }

  function publishClubEvent(eventName, properties) {
    if (!eventName) return;

    var detail = Object.assign(
      {
        event: eventName,
        event_id: createEventId(eventName),
        page_path: window.location.pathname
      },
      properties || {}
    );

    Object.keys(detail).forEach(function (key) {
      if (detail[key] === undefined || detail[key] === '') delete detail[key];
    });

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({}, detail));
    document.dispatchEvent(new CustomEvent('beefcake:club-event', { detail: detail }));
  }

  function activeTierForMap(map) {
    if (!map) return '';
    var active = map.querySelector('[data-bc-level-tab][data-bc-active="true"]');
    return active ? active.getAttribute('data-bc-tier') || '' : '';
  }

  function linkDestination(target) {
    var declaredDestination = target.getAttribute('data-bc-destination');
    if (declaredDestination) return declaredDestination;
    if (!target.href) return '';

    try {
      var url = new URL(target.href, window.location.origin);
      return url.origin === window.location.origin ? url.pathname + url.search + url.hash : url.href;
    } catch (error) {
      return target.getAttribute('href') || '';
    }
  }

  function readTrackingProperties(target) {
    var map = target.closest('[data-bc-level-map], [data-bc-club-map]');
    var authContainer = target.closest('[data-bc-club-auth-state]');
    var tier = target.getAttribute('data-bc-tier') ||
      target.getAttribute('data-bc-selected-tier') || activeTierForMap(map);
    var ctaText = target.getAttribute('data-bc-cta-text') || target.textContent || '';

    return {
      placement: target.getAttribute('data-bc-placement') || (map && map.getAttribute('data-bc-tracking-context')) || 'unknown',
      context: (map && (map.getAttribute('data-bc-tracking-context') || map.getAttribute('data-bc-club-map-placement'))) || 'storefront',
      tier: tier || undefined,
      level: target.getAttribute('data-bc-level') || undefined,
      track: target.getAttribute('data-bc-track') || undefined,
      platform: target.getAttribute('data-bc-platform') || undefined,
      destination: linkDestination(target) || undefined,
      cta_text: ctaText.trim().replace(/\s+/g, ' ') || undefined,
      auth_state: (authContainer && authContainer.getAttribute('data-bc-club-auth-state')) ||
        (document.querySelector('[data-bc-account-state="member"]') ? 'member' : 'guest')
    };
  }

  function preserveClubReturnUrl() {
    var currentReturnUrl = window.location.pathname + window.location.search + window.location.hash;

    document.querySelectorAll('[data-bc-event="club_join_click"], [data-bc-event="club_signin_click"]').forEach(function (link) {
      if (link.tagName !== 'A' || !link.href) return;

      try {
        var authUrl = new URL(link.href, window.location.origin);
        if (authUrl.origin !== window.location.origin || !/\/a\/account\/login\/?$/i.test(authUrl.pathname)) return;
        if (!authUrl.searchParams.has('return_url')) authUrl.searchParams.set('return_url', currentReturnUrl);
        link.href = authUrl.toString();
      } catch (error) {
        // Leave the server-rendered authentication fallback untouched.
      }
    });
  }

  function rememberAuthIntent(eventName, properties) {
    try {
      window.sessionStorage.setItem(AUTH_INTENT_KEY, JSON.stringify({
        intent: eventName === 'club_join_click' ? 'join' : 'sign_in',
        placement: properties.placement,
        source_path: window.location.pathname,
        created_at: Date.now()
      }));
    } catch (storageError) {
      // Authentication and navigation must keep working when storage is unavailable.
    }
  }

  function reportAuthCompletion() {
    if (!document.querySelector('[data-bc-account-state="member"]')) return;

    try {
      var storedIntent = window.sessionStorage.getItem(AUTH_INTENT_KEY);
      if (!storedIntent) return;

      var authIntent = JSON.parse(storedIntent);
      window.sessionStorage.removeItem(AUTH_INTENT_KEY);

      if (!authIntent.created_at || Date.now() - authIntent.created_at > AUTH_INTENT_MAX_AGE) return;
      publishClubEvent('club_auth_complete', {
        auth_intent: authIntent.intent,
        placement: authIntent.placement || 'unknown',
        source_path: authIntent.source_path || undefined,
        auth_state: 'member'
      });
    } catch (storageError) {
      // Do not block the private dashboard when browser storage is unavailable.
    }
  }

  function visibilityProperties(element) {
    var map = element.closest('[data-bc-level-map]');
    var panel = element.matches('[data-bc-level-panel]') ? element : element.closest('[data-bc-level-panel]');
    var lane = element.getAttribute('data-bc-benefit-lane');

    return {
      placement: (map && map.getAttribute('data-bc-tracking-context')) || 'unknown',
      tier: panel ? panel.getAttribute('data-bc-tier') || undefined : activeTierForMap(map) || undefined,
      level: panel ? panel.getAttribute('data-bc-level') || undefined : undefined,
      lane: lane || undefined,
      track: element.hasAttribute('data-bc-subscriber-track') ? 'subscriber' : undefined,
      auth_state: document.querySelector('[data-bc-account-state="member"]') ? 'member' : 'guest'
    };
  }

  function visibilityEventName(element) {
    if (element.matches('[data-bc-level-panel]')) return 'club_tier_view';
    if (element.matches('[data-bc-benefit-lane]')) return 'club_benefit_lane_view';
    if (element.matches('[data-bc-subscriber-track]')) return 'club_subscriber_track_view';
    if (element.matches('[data-bc-companion-dashboard]')) return 'club_dashboard_view';
    return '';
  }

  function connectVisibilityTracking() {
    var tracked = Array.prototype.slice.call(document.querySelectorAll(
      '[data-bc-level-panel], [data-bc-benefit-lane], [data-bc-subscriber-track], [data-bc-companion-dashboard]'
    ));
    if (!tracked.length) return;

    if (!('IntersectionObserver' in window)) {
      tracked.forEach(function (element) {
        if (element.hidden || element.getAttribute('data-bc-active') === 'false') return;
        publishClubEvent(visibilityEventName(element), visibilityProperties(element));
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.45) return;
        var eventName = visibilityEventName(entry.target);
        if (eventName) publishClubEvent(eventName, visibilityProperties(entry.target));
        observer.unobserve(entry.target);
      });
    }, { threshold: [0.45] });

    tracked.forEach(function (element) {
      observer.observe(element);
    });
  }

  function connectClubAnalytics() {
    if (document.documentElement.hasAttribute('data-bc-club-analytics-ready')) return;
    preserveClubReturnUrl();

    document.addEventListener('click', function (event) {
      var target = event.target instanceof Element ? event.target.closest('[data-bc-event]') : null;

      if (!target && typeof event.composedPath === 'function') {
        target = event.composedPath().find(function (node) {
          return node instanceof Element && node.matches('[data-bc-event]');
        });
      }

      if (!target) return;

      var eventName = target.getAttribute('data-bc-event');
      var properties = readTrackingProperties(target);
      publishClubEvent(eventName, properties);

      if (eventName === 'club_join_click' || eventName === 'club_signin_click') {
        rememberAuthIntent(eventName, properties);
      }
    });

    document.addEventListener('bc-level-map:change', function (event) {
      var map = event.target.closest('[data-bc-level-map]');
      var detail = event.detail || {};

      publishClubEvent('club_tier_select', {
        placement: (map && map.getAttribute('data-bc-tracking-context')) || 'unknown',
        tier: detail.tier || undefined,
        previous_tier: detail.previous_tier || undefined,
        level: detail.level || undefined,
        source: detail.source || undefined,
        auth_state: document.querySelector('[data-bc-account-state="member"]') ? 'member' : 'guest'
      });
    });

    document.addEventListener('beefcake:club-status', function () {
      publishClubEvent('club_status_loaded', { auth_state: 'member' });
    });

    document.addEventListener('beefcake:club-status-error', function (event) {
      publishClubEvent('club_status_error', {
        auth_state: 'member',
        reason: event.detail && event.detail.reason ? event.detail.reason : 'unavailable'
      });
    });

    if (document.body && document.body.classList.contains('bc-club-page')) {
      publishClubEvent('club_landing_view', {
        auth_state: document.querySelector('[data-bc-account-state="member"]') ? 'member' : 'guest'
      });
    }

    reportAuthCompletion();
    connectVisibilityTracking();
    document.documentElement.setAttribute('data-bc-club-analytics-ready', 'true');
  }

  function applyPageClass() {
    if (document.body && document.querySelector('.bc-club-hero, [data-bc-tracking-context="beefcake-club-page"]')) {
      document.body.classList.add('bc-club-page');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      applyPageClass();
      connectClubAnalytics();
    }, { once: true });
  } else {
    applyPageClass();
    connectClubAnalytics();
  }
})();
